import { findBookmarkName } from "@via/pages/data/file-organizer/helpers.ts";
import { JSX, useEffect, useState } from "react";
import DataSourceTitle from "@via/pages/data/data-sources/data-source-title.tsx";
import BaseSpaceLogo from "/basespace-logo.png";
import { DataSourceComponentView } from "@via/utils/interfaces.tsx";
import FileOrganizer from "@via/pages/data/file-organizer/file-organizer.tsx";
import { BaseSpaceFile, DataSourceProvider, type SelectedFile } from "common";
import { FileOrganizerProvider } from "@via/context/file-organizer-context.tsx";
import { useBaseSpaceConnection } from "@via/hooks/useBaseSpaceConnection.tsx";
import BaseSpaceFolderBrowser from "@via/pages/data/data-sources/token-based-data-sources/basespace/basespace-folder-browser.tsx";
import { useSearchParams } from "react-router-dom";
import { useGetDataSourceList } from "@via/pages/data/data-connections/data-connections.api.tsx";

export function BaseSpace(): JSX.Element {
  const [searchParams] = useSearchParams();
  const bookmarkId = searchParams.get("bookmark");
  const { data: bookmarkList } = useGetDataSourceList();

  useEffect(() => {
    if (bookmarkId && bookmarkList?.length) {
      const selectedDatasource = bookmarkList.find(
        item => item.id === Number(bookmarkId)
      );

      if (selectedDatasource?.credentialId) {
        const bookmarkCredentials = {
          tokenId: selectedDatasource.credentialId,
        };
        setConnectionCredentials(bookmarkCredentials);
      }
    }
  }, [bookmarkId, bookmarkList]);

  const { connectionCredentials, setConnectionCredentials } =
    useBaseSpaceConnection();

  const [currentView, setCurrentView] = useState<DataSourceComponentView>(
    DataSourceComponentView.FolderBrowser
  );
  const [selectedFiles, setSelectedFiles] = useState<SelectedFile[]>([]);

  const updateSelectedFiles = (items: BaseSpaceFile[]) => {
    const formattedSelectedFiles = items.map(item => ({
      id: item.id,
      name: item.name,
      size: item.size,
      dateModified: "",
      type: "content",
    }));
    setSelectedFiles(formattedSelectedFiles as SelectedFile[]);
    setCurrentView(DataSourceComponentView.FileOrganizer);
  };

  const setCurrentViewToFolderBrowser = () => {
    setCurrentView(DataSourceComponentView.FolderBrowser);
  };

  useEffect(() => {
    if (connectionCredentials) {
      setCurrentView(DataSourceComponentView.FolderBrowser);
    }
  }, [connectionCredentials]);

  return (
    <div className="flex-auto">
      <DataSourceTitle logoPath={BaseSpaceLogo} title="BaseSpace" />
      {
        <div>
          {currentView === DataSourceComponentView.FileOrganizer ? (
            <FileOrganizerProvider>
              <FileOrganizer
                importedFiles={selectedFiles}
                globalBucketName={""}
                onBackToSelectionClick={setCurrentViewToFolderBrowser}
                credentialId={null}
                serviceTokenId={connectionCredentials?.tokenId}
                dataSourceName={findBookmarkName(bookmarkList, bookmarkId)}
                provider={DataSourceProvider.BaseSpace}
              />
            </FileOrganizerProvider>
          ) : (
            <BaseSpaceFolderBrowser
              onSelectedFilesUpdate={updateSelectedFiles}
            />
          )}
        </div>
      }
    </div>
  );
}
